import { render, staticRenderFns } from "./sendKinsCard.vue?vue&type=template&id=60a0d828&scoped=true&"
import script from "./sendKinsCard.vue?vue&type=script&lang=js&"
export * from "./sendKinsCard.vue?vue&type=script&lang=js&"
import style0 from "./sendKinsCard.vue?vue&type=style&index=0&id=60a0d828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0d828",
  null
  
)

export default component.exports